
// Premium TuPlazaIA Logo Component with Lince Ibérico Mascot
// The Iberian Lynx is the mascot of TuPlazaIA - a distinctive spotted wild cat native to Spain
export const TuPlazaIALogo = ({ size = 48, showText = true, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Background circle */}
      <circle cx="32" cy="32" r="30" fill="url(#linceGradient)" />
      
      {/* Lince Ibérico face - main shape */}
      <ellipse cx="32" cy="30" rx="20" ry="16" fill="#D4A574" />
      
      {/* Characteristic Lince ear tufts (pinceles) */}
      <path d="M16 14L11 2L20 12Z" fill="#8B5A2B" />
      <path d="M48 14L53 2L44 12Z" fill="#8B5A2B" />
      <path d="M16 14L13 6L19 12Z" fill="#2D1B0E" />
      <path d="M48 14L51 6L45 12Z" fill="#2D1B0E" />
      
      {/* Inner ears */}
      <path d="M17 16L14 8L21 14Z" fill="#F4D6B8" />
      <path d="M47 16L50 8L43 14Z" fill="#F4D6B8" />
      
      {/* Facial markings - cheek fur (patillas del lince) */}
      <path d="M12 28Q8 32 10 40Q14 38 16 32Z" fill="#C4956A" />
      <path d="M52 28Q56 32 54 40Q50 38 48 32Z" fill="#C4956A" />
      
      {/* White facial patches */}
      <ellipse cx="24" cy="28" rx="6" ry="7" fill="#F5E6D3" />
      <ellipse cx="40" cy="28" rx="6" ry="7" fill="#F5E6D3" />
      
      {/* Eyes - intense amber lynx eyes */}
      <ellipse cx="24" cy="27" rx="4" ry="5" fill="#F59E0B" />
      <ellipse cx="40" cy="27" rx="4" ry="5" fill="#F59E0B" />
      <circle cx="24" cy="27" r="2.5" fill="#1E293B" />
      <circle cx="40" cy="27" r="2.5" fill="#1E293B" />
      <circle cx="25" cy="26" r="1" fill="white" />
      <circle cx="41" cy="26" r="1" fill="white" />
      
      {/* Nose */}
      <path d="M32 33L29 36L32 38L35 36Z" fill="#2D1B0E" />
      
      {/* Mouth */}
      <path d="M32 38L32 40" stroke="#2D1B0E" strokeWidth="1" strokeLinecap="round" />
      <path d="M28 41Q32 44 36 41" stroke="#2D1B0E" strokeWidth="1" fill="none" strokeLinecap="round" />
      
      {/* Spots pattern - characteristic of Iberian Lynx */}
      <circle cx="18" cy="24" r="1.5" fill="#8B5A2B" />
      <circle cx="46" cy="24" r="1.5" fill="#8B5A2B" />
      <circle cx="20" cy="34" r="1" fill="#8B5A2B" />
      <circle cx="44" cy="34" r="1" fill="#8B5A2B" />
      <circle cx="28" cy="36" r="0.8" fill="#8B5A2B" />
      <circle cx="36" cy="36" r="0.8" fill="#8B5A2B" />
      
      {/* Whiskers */}
      <path d="M18 34L8 32" stroke="#2D1B0E" strokeWidth="0.6" strokeLinecap="round" />
      <path d="M18 36L8 37" stroke="#2D1B0E" strokeWidth="0.6" strokeLinecap="round" />
      <path d="M18 38L9 42" stroke="#2D1B0E" strokeWidth="0.6" strokeLinecap="round" />
      <path d="M46 34L56 32" stroke="#2D1B0E" strokeWidth="0.6" strokeLinecap="round" />
      <path d="M46 36L56 37" stroke="#2D1B0E" strokeWidth="0.6" strokeLinecap="round" />
      <path d="M46 38L55 42" stroke="#2D1B0E" strokeWidth="0.6" strokeLinecap="round" />
      
      {/* Graduation cap */}
      <path d="M32 8L16 16L32 24L48 16Z" fill="#1E293B" />
      <rect x="30" y="6" width="4" height="4" fill="#F59E0B" />
      <path d="M34 6L38 2L42 6" fill="#F59E0B" stroke="#F59E0B" strokeWidth="1" />
      
      <defs>
        <linearGradient id="linceGradient" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6366F1" />
          <stop offset="1" stopColor="#8B5CF6" />
        </linearGradient>
      </defs>
    </svg>
    {showText && (
      <span className="text-2xl font-extrabold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
        TuPlazaIA
      </span>
    )}
  </div>
);

// Simplified Lince Logo for smaller spaces
export const TuPlazaIALogoSmall = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="30" fill="url(#linceGradientSmall)" />
    
    {/* Simplified Lince face */}
    <ellipse cx="32" cy="32" rx="18" ry="14" fill="#D4A574" />
    
    {/* Ear tufts */}
    <path d="M17 18L13 8L21 16Z" fill="#8B5A2B" />
    <path d="M47 18L51 8L43 16Z" fill="#8B5A2B" />
    
    {/* Eyes */}
    <ellipse cx="25" cy="30" rx="3" ry="4" fill="#F59E0B" />
    <ellipse cx="39" cy="30" rx="3" ry="4" fill="#F59E0B" />
    <circle cx="25" cy="30" r="2" fill="#1E293B" />
    <circle cx="39" cy="30" r="2" fill="#1E293B" />
    
    {/* Nose */}
    <path d="M32 35L30 37L32 39L34 37Z" fill="#2D1B0E" />
    
    {/* Spots */}
    <circle cx="20" cy="28" r="1" fill="#8B5A2B" />
    <circle cx="44" cy="28" r="1" fill="#8B5A2B" />
    
    <defs>
      <linearGradient id="linceGradientSmall" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6366F1" />
        <stop offset="1" stopColor="#8B5CF6" />
      </linearGradient>
    </defs>
  </svg>
);

// Lince mascot for larger displays (dashboard, etc)
export const LinceMascot = ({ size = 120, mood = "happy", className = "" }) => (
  <div className={className}>
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Full body Lince Ibérico */}
      
      {/* Body */}
      <ellipse cx="60" cy="80" rx="35" ry="25" fill="#D4A574" />
      
      {/* Spots on body */}
      <circle cx="45" cy="75" r="3" fill="#8B5A2B" />
      <circle cx="55" cy="85" r="2.5" fill="#8B5A2B" />
      <circle cx="70" cy="78" r="2" fill="#8B5A2B" />
      <circle cx="80" cy="85" r="2.5" fill="#8B5A2B" />
      
      {/* Head */}
      <ellipse cx="60" cy="45" rx="28" ry="22" fill="#D4A574" />
      
      {/* Ear tufts (pinceles) - distinctive of Iberian Lynx */}
      <path d="M38 28L30 10L44 24Z" fill="#8B5A2B" />
      <path d="M82 28L90 10L76 24Z" fill="#8B5A2B" />
      <path d="M38 28L33 16L42 24Z" fill="#2D1B0E" />
      <path d="M82 28L87 16L78 24Z" fill="#2D1B0E" />
      
      {/* Inner ears */}
      <path d="M40 30L35 18L46 28Z" fill="#F4D6B8" />
      <path d="M80 30L85 18L74 28Z" fill="#F4D6B8" />
      
      {/* Cheek fur (patillas) */}
      <path d="M28 42Q20 50 24 62Q32 58 34 48Z" fill="#C4956A" />
      <path d="M92 42Q100 50 96 62Q88 58 86 48Z" fill="#C4956A" />
      
      {/* White facial patches */}
      <ellipse cx="48" cy="42" rx="10" ry="12" fill="#F5E6D3" />
      <ellipse cx="72" cy="42" rx="10" ry="12" fill="#F5E6D3" />
      
      {/* Eyes */}
      <ellipse cx="48" cy="40" rx="6" ry="8" fill="#F59E0B" />
      <ellipse cx="72" cy="40" rx="6" ry="8" fill="#F59E0B" />
      <ellipse cx="48" cy="40" rx="3.5" ry="5" fill="#1E293B" />
      <ellipse cx="72" cy="40" rx="3.5" ry="5" fill="#1E293B" />
      <circle cx="50" cy="38" r="2" fill="white" />
      <circle cx="74" cy="38" r="2" fill="white" />
      
      {/* Nose */}
      <path d="M60 50L55 56L60 60L65 56Z" fill="#2D1B0E" />
      
      {/* Mouth - changes based on mood */}
      {mood === "happy" && (
        <>
          <path d="M60 60V64" stroke="#2D1B0E" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M52 66Q60 72 68 66" stroke="#2D1B0E" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        </>
      )}
      {mood === "thinking" && (
        <>
          <path d="M60 60V63" stroke="#2D1B0E" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M54 66L66 66" stroke="#2D1B0E" strokeWidth="1.5" strokeLinecap="round" />
        </>
      )}
      {mood === "excited" && (
        <>
          <path d="M60 60V62" stroke="#2D1B0E" strokeWidth="1.5" strokeLinecap="round" />
          <ellipse cx="60" cy="68" rx="6" ry="4" fill="#2D1B0E" />
          <path d="M56 67Q60 64 64 67" fill="#E57373" />
        </>
      )}
      
      {/* Facial spots */}
      <circle cx="38" cy="38" r="2" fill="#8B5A2B" />
      <circle cx="82" cy="38" r="2" fill="#8B5A2B" />
      <circle cx="42" cy="52" r="1.5" fill="#8B5A2B" />
      <circle cx="78" cy="52" r="1.5" fill="#8B5A2B" />
      
      {/* Whiskers */}
      <path d="M42 54L26 50" stroke="#2D1B0E" strokeWidth="0.8" strokeLinecap="round" />
      <path d="M42 56L24 56" stroke="#2D1B0E" strokeWidth="0.8" strokeLinecap="round" />
      <path d="M42 58L26 64" stroke="#2D1B0E" strokeWidth="0.8" strokeLinecap="round" />
      <path d="M78 54L94 50" stroke="#2D1B0E" strokeWidth="0.8" strokeLinecap="round" />
      <path d="M78 56L96 56" stroke="#2D1B0E" strokeWidth="0.8" strokeLinecap="round" />
      <path d="M78 58L94 64" stroke="#2D1B0E" strokeWidth="0.8" strokeLinecap="round" />
      
      {/* Front paws */}
      <ellipse cx="42" cy="100" rx="8" ry="6" fill="#D4A574" />
      <ellipse cx="78" cy="100" rx="8" ry="6" fill="#D4A574" />
      <ellipse cx="42" cy="102" rx="6" ry="3" fill="#F4D6B8" />
      <ellipse cx="78" cy="102" rx="6" ry="3" fill="#F4D6B8" />
      
      {/* Tail */}
      <path d="M95 80Q110 75 105 90Q100 95 95 85" fill="#D4A574" />
      <circle cx="103" cy="82" r="2" fill="#8B5A2B" />
      <ellipse cx="104" cy="88" rx="4" ry="3" fill="#2D1B0E" />
    </svg>
  </div>
);

// Aliases for backward compatibility
export const OposaiLogo = TuPlazaIALogo;
export const OposaiLogoSmall = TuPlazaIALogoSmall;

export default TuPlazaIALogo;
